import { render } from "./setOrganizationprovider.vue?vue&type=template&id=b17fd8fc"
import script from "./setOrganizationprovider.vue?vue&type=script&lang=js"
export * from "./setOrganizationprovider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__